
import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Tag } from "lucide-react";

const studiesResources = [
  {
    title: "Machine Learning for Volatility Prediction",
    author: "Research Team",
    date: "April 2025",
    description: "Comprehensive study on using ML techniques for market volatility prediction",
    tags: ["Machine Learning", "Volatility", "Prediction"]
  },
  {
    title: "Technical Analysis Pattern Detection",
    author: "Quant Team",
    date: "March 2025",
    description: "Study on automated identification of chart patterns for trading signals",
    tags: ["Technical Analysis", "Pattern Recognition", "Algorithms"]
  },
  {
    title: "Market Microstructure Analysis",
    author: "Market Team",
    date: "February 2025",
    description: "Deep dive into order book dynamics and market microstructure",
    tags: ["Microstructure", "Order Book", "HFT"]
  }
];

export const DocsStudiesSection = () => (
  <div className="space-y-6">
    {studiesResources.map((study, index) => (
      <Card key={index} className="bg-gray-800/40 border-gray-700/50 overflow-hidden hover:bg-gray-800/70 transition-colors">
        <div className="p-6">
          <h3 className="text-xl font-semibold text-white mb-3">{study.title}</h3>
          <div className="flex items-center text-sm text-gray-400 mb-4">
            <span>{study.author}</span>
            <span className="mx-2">•</span>
            <span>{study.date}</span>
          </div>
          <p className="text-gray-300 mb-4">{study.description}</p>
          <div className="flex flex-wrap gap-2">
            {study.tags.map((tag, tagIndex) => (
              <Badge 
                key={tagIndex} 
                variant="outline" 
                className="bg-gray-700/30 hover:bg-gray-700/50 text-gray-300"
              >
                <Tag className="h-3 w-3 mr-1" />
                {tag}
              </Badge>
            ))}
          </div>
          <div className="mt-4 flex justify-end">
            <Button size="sm" className="bg-blue-600 hover:bg-blue-700">
              Read Study
            </Button>
          </div>
        </div>
      </Card>
    ))}
  </div>
);
